<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Authorization Konfiguration</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" style="" >
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <select class="form-select "
                id="Status"
                [(ngModel)]="authModel.authType" (ngModelChange)="authModel.authType = $event">
          <option *ngFor="let item of AuthType" [ngValue]="item.key">
            {{ item.Bezeichnung }}
          </option>
        </select>
        <label for="type">Type</label>
      </div>
    </div>
  </div>
  @if(authModel.authType > 0)
  {
    @switch (authModel.authType)
    {
      @case (1)
      {
        <div class="row">
          <div class="col" >
            <div class="row">
              <div class="col" >
                <div class="row">
                  <div class="col" >
                    <div class="row">
                      <div class="col" >
                        <div class="form-floating mb-3">
                          <input type="text"  class="form-control" id="username"  [(ngModel)]="authModel.username">
                          <label for="username">Username</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" >
                <div class="row">
                  <div class="col" >
                    <div class="row">
                      <div class="col" >
                        <div class="form-floating mb-3">
                          <input type="text"  class="form-control" id="password"  [(ngModel)]="authModel.password">
                          <label for="password">Password</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @case (2)
      {
        <div class="row">
          <div class="col" >
            <div class="row">
              <div class="col" >
                <div class="row">
                  <div class="col" >
                    <div class="form-floating mb-3">
                      <input type="text"  class="form-control" id="token"  [(ngModel)]="authModel.token">
                      <label for="token">token</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @case (3)
      @case (4)
      {
        <div class="row">
          <div class="col" >
            <div class="row">
              <div class="col" >
                <div class="form-floating mb-3">
                  <input type="text"  class="form-control" id="apiKeyName"  [(ngModel)]="authModel.apiKeyName">
                  <label for="apiKeyName">Name</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="apiKeyValue"  [(ngModel)]="authModel.apiKeyValue">
              <label for="apiKeyValue">API-Key</label>
            </div>
          </div>
        </div>
      }
      @case (5)
      {
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="hmacHeaderName"  [(ngModel)]="authModel.hmacHeaderName">
              <label for="hmacHeaderName">Name</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="hmacSecret"  [(ngModel)]="authModel.hmacSecret">
              <label for="hmacSecret">Secret</label>
            </div>
          </div>
        </div>
      }
      @case (6)
      {
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <select class="form-select "
                      id="Status"
                      [(ngModel)]="authModel.oAuthGrantType" (ngModelChange)="authModel.oAuthGrantType = $event">
                <option *ngFor="let item of OAuthGrantType" [ngValue]="item.key">
                  {{ item.Bezeichnung }}
                </option>
              </select>
              <label for="type">Grand Type</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthTokenUrl"  [(ngModel)]="authModel.oAuthTokenUrl">
              <label for="oAuthTokenUrl">Tocken Url</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthScope"  [(ngModel)]="authModel.oAuthScope">
              <label for="oAuthScope">Scope</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthClientId"  [(ngModel)]="authModel.oAuthClientId">
              <label for="oAuthClientId">Client ID</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthClientSecret"  [(ngModel)]="authModel.oAuthClientSecret">
              <label for="oAuthClientSecret">Client Secret</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthUsername"  [(ngModel)]="authModel.oAuthUsername">
              <label for="oAuthUsername">Username</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthPassword"  [(ngModel)]="authModel.oAuthPassword">
              <label for="oAuthPassword">Password</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" >
            <div class="form-floating mb-3">
              <input type="text"  class="form-control" id="oAuthRefreshToken"  [(ngModel)]="authModel.oAuthRefreshToken">
              <label for="oAuthRefreshToken">Refresh Token</label>
            </div>
          </div>
        </div>
      }
    }
  }
  <div class="row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-primary" (click)="Save()">Speichern</div>
    </div>
  </div>
</div>


<ng-template #successVerTpl> Aktion erfolgreich! </ng-template>
<ng-template #FaildVerTpl> Aktion fehlgeschlagen! </ng-template>
